import { useEffect } from 'react';

/**
 * Redirects HTTP to HTTPS in production. Replaces react-https-redirect.
 *
 * In development (NODE_ENV !== 'production') we never redirect so that local
 * http://localhost dev servers keep working. Localhost/127.0.0.1 are also
 * skipped as an extra safety net.
 */
export function useHttpsRedirect() {
  useEffect(() => {
    if (process.env.NODE_ENV !== 'production') return;
    if (typeof window === 'undefined') return;

    const { protocol, hostname, href } = window.location;
    if (protocol === 'https:') return;
    if (hostname === 'localhost' || hostname === '127.0.0.1') return;

    window.location.replace(`https:${href.substring(protocol.length)}`);
  }, []);
}
